<div class="row">
  <div class="col-xl-6 offset-xl-3">
    <h3 class="text-block mt-5 mb-4 text-center">
      <strong>General Icons</strong>
    </h3>
    <ul class="vb__utils__iconPresent list-unstyled">
      <li *ngFor="let icon of icons" nz-tooltip nzTooltipPlacement="top" [nzTooltipTitle]="'fe ' + icon">
        <i [class]="'fe ' + icon"></i>
      </li>
    </ul>
  </div>
</div>